import { render, staticRenderFns } from "./menucolonneverte_caracteristiques_header.vue?vue&type=template&id=3316f615"
import script from "./menucolonneverte_caracteristiques_header.js?vue&type=script&lang=js&external"
export * from "./menucolonneverte_caracteristiques_header.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports